import gql from 'graphql-tag';
import { gqlClient } from '../../../gql-client';
import { logger } from '@getvim/vim-connect-logger';
import { LookupInput } from '../../../types';

const lookupLogger = logger.scope('prior-auth-lookup-logger');

const GET_STANDARD_TOKEN_QUERY = gql`
  query getStandardToken($input: GetStandardTokenInput!) {
    getStandardToken(input: $input) {
      memberToken
    }
  }
`;

// remove when remove the "shouldUseRuntimeToken" feature flag
// remove also in BFF
export const getStandardToken = async (
  source: string | undefined,
  input: LookupInput,
): Promise<string | undefined> => {
  try {
    const { data } = await gqlClient.query({
      query: GET_STANDARD_TOKEN_QUERY,
      variables: { input },
      fetchPolicy: 'no-cache',
      context: {
        uri: '/prior-auth/api/graphql',
        headers: {
          'x-source': source,
        },
      },
    });

    return data?.getStandardToken.memberToken;
  } catch (error) {
    lookupLogger.error('Lookup query failed!', { error });
  }
};
